import enums from "@/services/enums";

export function AliasAndCalculate(parameters) {
  const keys = Object.keys(parameters);
  if (keys.length < 2) {
    throw new Error("Please include at least one data field");
  }
  const result = {};
  for (const key of keys) {
    const keyLower = key.toLowerCase();
    // Check if it's an alias, and validate
    const alias = FieldAliases.find(
      item => item.alias.toLowerCase() === keyLower
    );
    if (alias) {
      if (parameters[key] !== "") {
        if (alias.userInput === "numeric") {
          if (isNaN(parameters[key])) {
            throw new Error(
              "Value " +
                parameters[key] +
                " for field " +
                key +
                " is not numeric"
            );
          }
          result[alias.modelField] = Number(parameters[key]);
          if (alias.numericMin !== undefined) {
            if (result[alias.modelField] < alias.numericMin) {
              throw new Error(
                "Value " +
                  parameters[key] +
                  " for field " +
                  key +
                  " is below the minimum of " +
                  alias.numericMin
              );
            }
          }
          if (alias.numericMax !== undefined) {
            if (result[alias.modelField] > alias.numericMax) {
              throw new Error(
                "Value " +
                  parameters[key] +
                  " for field " +
                  key +
                  " is above the maximum of " +
                  alias.numericMax
              );
            }
          }
        } else if (alias.userInput === "dropdown") {
          const paramLower = parameters[key].toLowerCase();
          let dropdownMap = enums[alias.modelField].find(
            item => item.name.toLowerCase() === paramLower
          );
          if (!dropdownMap) {
            dropdownMap = enums[alias.modelField].find(
              item =>
                Array.isArray(item.alternates) &&
                item.alternates.includes(paramLower)
            );
          }
          if (!dropdownMap) {
            throw new Error(
              "Value " + parameters[key] + " for field " + key + " is not valid"
            );
          }
          result[alias.modelField] = dropdownMap.code;
        } else {
          result[alias.modelField] = parameters[key];
        }
      }
    } else {
      throw new Error("The column '" + key + "' is not an accepted field name");
    }
  }
  // Now result is all converted over to model names

  // Ensure we have a record id
  if (!result.record_id) {
    throw new Error("Row does not have a 'Record ID' field");
  }

  // // Ensure we have a first name
  // if (!result.first_name) {
  //   throw new Error("Row does not have a 'First Name' field");
  // }

  // // Ensure we have a last name
  // if (!result.last_name) {
  //   throw new Error("Row does not have a 'Last Name' field");
  // }

  // // Ensure we have a email address
  // if (!result.email_address) {
  //   throw new Error("Row does not have a 'Email Address' field");
  // }

  // // Ensure we have a phone number
  // if (result.applicant_phone === undefined) {
  //   throw new Error("Row does not have a 'Phone Number' field");
  // }

  // Ensure we have a FICO score
  if (result.opp_fico_score === undefined) {
    ///result.opp_fico_score = -9999;
    throw new Error("Fico Score is a required field");
  }

  // Ensure we have a Household income score
  if (result.opp_declared_household_income === undefined) {
    throw new Error("Household Income is a required field");
  }

  // Ensure we have a Personal Debt
  if (result._personaldebt === undefined) {
    throw new Error("Personal Debt is a required field");
  }

  // Calculate gross business surplus
  // Must have both biz income & biz expenses to calculate
  if (
    result.opp_declared_business_total_income !== undefined &&
    result.opp_declared_business_expenses !== undefined
  ) {
    const numericBusinessIncome =
      result.opp_declared_business_total_income || 0;
    const numericBusinessExpenses = result.opp_declared_business_expenses || 0;
    result.opp_declared_gross_business_surplus =
      numericBusinessIncome - numericBusinessExpenses;
  }

  // Calculate equity
  // Must have both biz assets & biz liabilities to calculate
  if (
    result.opp_total_assets !== undefined &&
    result.opp_total_liabilities !== undefined
  ) {
    const numericAssets = result.opp_total_assets || 0;
    const numericLiabilities = result.opp_total_liabilities || 0;
    result.equity = numericAssets - numericLiabilities;
  }

  // Calculate debt income ratio
  // Must have both personal debt & household income to calculate
  if (
    result._personaldebt !== undefined &&
    result.opp_declared_household_income !== undefined
  ) {
    const numericDebt = result._personaldebt || 0;
    if (result.opp_declared_household_income) {
      result.opp_declared_personal_debt_income_ratio =
        numericDebt / result.opp_declared_household_income;
    } else {
      result.opp_declared_personal_debt_income_ratio = null;
    }
  }
  delete result._personaldebt;

  // Calculate days in business
  // Must have either months in biz or years in biz to calculate
  if (
    result._monthsinbusiness !== undefined ||
    result._yearsinbusiness !== undefined
  ) {
    const bizmonths = result._monthsinbusiness || 0;
    const bizyears = result._yearsinbusiness || 0;
    result.model_date_opp_established_date =
      bizyears * 365.0 + bizmonths * 30.0;
  }
  delete result._monthsinbusiness;
  delete result._yearsinbusiness;

  return result;
}

// BEGINNING OF EXPERIMENT FOR BREE
export function AliasAndCalculateTable(parameters) {
  const keys = Object.keys(parameters);
  if (keys.length < 2) {
    throw new Error("Please include at least one data field");
  }
  const result = {};
  for (const key of keys) {
    const keyLower = key.toLowerCase();
    // Check if it's an alias, and validate
    const alias = FieldAliases.find(
      item => item.alias.toLowerCase() === keyLower
    );
    if (alias) {
      if (parameters[key] !== "") {
        if (alias.userInput === "numeric") {
          if (isNaN(parameters[key])) {
            throw new Error(
              "Value " +
                parameters[key] +
                " for field " +
                key +
                " is not numeric"
            );
          }
          result[alias.modelField] = Number(parameters[key]);
          if (alias.numericMin !== undefined) {
            if (result[alias.modelField] < alias.numericMin) {
              throw new Error(
                "Value " +
                  parameters[key] +
                  " for field " +
                  key +
                  " is below the minimum of " +
                  alias.numericMin
              );
            }
          }
          if (alias.numericMax !== undefined) {
            if (result[alias.modelField] > alias.numericMax) {
              throw new Error(
                "Value " +
                  parameters[key] +
                  " for field " +
                  key +
                  " is above the maximum of " +
                  alias.numericMax
              );
            }
          }
        } else if (alias.userInput === "dropdown") {
          const paramLower = parameters[key].toLowerCase();
          let dropdownMap = enums[alias.modelField].find(
            item => item.name.toLowerCase() === paramLower
          );
          if (!dropdownMap) {
            dropdownMap = enums[alias.modelField].find(
              item =>
                Array.isArray(item.alternates) &&
                item.alternates.includes(paramLower)
            );
          }
          if (!dropdownMap) {
            throw new Error(
              "Value " + parameters[key] + " for field " + key + " is not valid"
            );
          }
          result[alias.modelField] = dropdownMap.code;
        } else {
          result[alias.modelField] = parameters[key];
        }
      }
    } else {
      throw new Error("The column '" + key + "' is not an accepted field name");
    }
  }
  // Now result is all converted over to model names

  // Ensure we have a record id
  if (!result.record_id) {
    throw new Error("Row does not have a 'Record ID' field");
  }

  // Ensure we have a first name
  if (!result.first_name) {
    throw new Error("Row does not have a 'First Name' field");
  }

  // Ensure we have a last name
  if (!result.last_name) {
    throw new Error("Row does not have a 'Last Name' field");
  }

  // Ensure we have a email address
  if (!result.email_address) {
    throw new Error("Row does not have a 'Email Address' field");
  }

  // Ensure we have a phone number
  if (result.applicant_phone === undefined) {
    throw new Error("Row does not have a 'Phone Number' field");
  }

  // Ensure we have a FICO score
  if (result.opp_fico_score === undefined) {
    ///result.opp_fico_score = -9999;
    throw new Error("Fico Score is a required field");
  }

  // Ensure we have a Household income score
  if (result.opp_declared_household_income === undefined) {
    throw new Error("Household Income is a required field");
  }

  // Ensure we have a Personal Debt
  if (result._personaldebt === undefined) {
    throw new Error("Personal Debt is a required field");
  }

  // Calculate gross business surplus
  // Must have both biz income & biz expenses to calculate
  if (
    result.opp_declared_business_total_income !== undefined &&
    result.opp_declared_business_expenses !== undefined
  ) {
    const numericBusinessIncome =
      result.opp_declared_business_total_income || 0;
    const numericBusinessExpenses = result.opp_declared_business_expenses || 0;
    result.opp_declared_gross_business_surplus =
      numericBusinessIncome - numericBusinessExpenses;
  }

  // Calculate equity
  // Must have both biz assets & biz liabilities to calculate
  if (
    result.opp_total_assets !== undefined &&
    result.opp_total_liabilities !== undefined
  ) {
    const numericAssets = result.opp_total_assets || 0;
    const numericLiabilities = result.opp_total_liabilities || 0;
    result.equity = numericAssets - numericLiabilities;
  }

  // Calculate debt income ratio
  // Must have both personal debt & household income to calculate
  if (
    result._personaldebt !== undefined &&
    result.opp_declared_household_income !== undefined
  ) {
    const numericDebt = result._personaldebt || 0;
    if (result.opp_declared_household_income) {
      result.opp_declared_personal_debt_income_ratio =
        numericDebt / result.opp_declared_household_income;
    } else {
      result.opp_declared_personal_debt_income_ratio = null;
    }
  }
  delete result._personaldebt;

  // Calculate days in business
  // Must have either months in biz or years in biz to calculate
  if (
    result._monthsinbusiness !== undefined ||
    result._yearsinbusiness !== undefined
  ) {
    const bizmonths = result._monthsinbusiness || 0;
    const bizyears = result._yearsinbusiness || 0;
    result.model_date_opp_established_date =
      bizyears * 365.0 + bizmonths * 30.0;
  }
  delete result._monthsinbusiness;
  delete result._yearsinbusiness;

  return result;
}
// END OF EXPERIMENT FOR BREE

export function PrepForCRMSubmit(parameters) {
  const keys = Object.keys(parameters);
  const result = {};
  //Array.prototype.push.apply(FieldAliases, ContactAliases);
  for (const key of keys) {
    const keyLower = key.toLowerCase();
    // Check if it's an modelField, and validate
    const modelField = FieldAliases.find(item => item.modelField === keyLower);
    if (modelField) {
      if (parameters[key] !== "") {
        result[modelField.crmfeild] = parameters[key];
      }
    } else {
      throw new Error("The column '" + key + "' is not an accepted field name");
    }
  }
  // Now result is all converted over to crm names

  /// Convert Days Since Established to Years
  if (result.new_days_since_established != undefined) {
    result["new_yearssinceestablished"] =
      result["new_days_since_established"] / 365;
    delete result["new_days_since_established"];
  }
  return result;
}

export const FieldAliases = [
  {
    alias: "Record ID",
    description:
      "A unique identifier for each row in the Batch CSV. Each loan must have a different Record ID. A Record ID is not required for the single score feature.",
    example: "123456",
    modelField: "record_id",
    userInput: "none"
  },
  {
    alias: "Owner",
    description:
      "Will be set to 'crm_user' to signal the lead came from levelfi",
    example: "crm_user",
    userInput: "none",
    crmfeild: "ownerid"
  },
  {
    alias: "Requested Loan Amount",
    description: "The value of the loan.",
    example: "30000",
    modelField: "total_loan_amount",
    userInput: "numeric",
    crmfeild: "new_requestedamount"
  },
  {
    alias: "Total Collateral Value",
    description:
      "The total collateral value. Total assets owned clear and free including what will be used for the loan purpose if purchasing equipment, vehicles, long term assets.",
    example: "1000",
    modelField: "total_collateral_value",
    userInput: "numeric",
    crmfeild: "new_totalcollateralvalue",
    instructions:
      "Total assets owned clear and free including what will be used for the loan purpose if purchasing equipment, vehicles, and/or long-term assets."
  },
  {
    alias: "FICO Score",
    description: "The FICO 2008 credit score.",
    example: "700",
    modelField: "opp_fico_score",
    userInput: "numeric",
    numericMin: 300,
    numericMax: 850,
    crmfeild: "new_creditscore",
    instructions:
      "Enter the borrower’s best estimate of their FICO score. Note that any late payments on mortgage/vehicle accounts or having defaulted on any other accounts within the last six months will disqualify the applicant. "
  },
  {
    alias: "Industry Type",
    description:
      "The NAICS industry code that describes the business's industry.",
    example: "SERVICE",
    modelField: "opp_naics_code",
    userInput: "dropdown",
    crmfeild: "new_naicssector"
  },
  {
    alias: "Years in Business",
    description: "The number of years the business has been operating.",
    // preFieldNote: "Time the business has been operating:",
    fieldIndent: false,
    example: "10",
    modelField: "_yearsinbusiness",
    userInput: "numeric"
  },
  {
    alias: "Months in Business",
    description:
      "The number of months the business has been operating (will be added to 'Years in Business').",
    fieldIndent: false,
    example: "2",
    modelField: "_monthsinbusiness",
    userInput: "numeric",
    numericMin: 0,
    numericMax: 11
  },
  {
    alias: "Company Type",
    description:
      "The organizational structure of the business: Corporation, General Partnership, Limited Liability Corporation (LLC), Limited Partnership, Non-Profit, Sole Proprietorship/Individual.",
    example: "Sole Proprietorship/Individual",
    modelField: "opp_company_type",
    userInput: "dropdown",
    crmfeild: "new_businessownership"
  },
  {
    alias: "Total Business Assets",
    description:
      "The total value of the business's assets. Please use current market value of assets clear and free that could be used or towards leverage of the loan. This includes accounts receivable if valid.",
    example: "5000",
    modelField: "opp_total_assets",
    userInput: "numeric",
    crmfeild: "new_totalassets",
    instructions:
      "Please use current market value of assets clear and free that could be used towards securing the loan. This includes accounts receivable if valid."
  },
  {
    alias: "Total Business Liabilities",
    description:
      "The total value of the business's liabilities. Please include any short term and long-term debt.",
    example: "0",
    modelField: "opp_total_liabilities",
    userInput: "numeric",
    crmfeild: "new_totalliabilities",
    instructions: "Please include any short-term and long-term debt."
  },
  {
    alias: "Monthly Business Revenue",
    description:
      "The business's income for a typical month. All revenue sources from business.",
    example: "20000",
    modelField: "opp_declared_business_total_income",
    userInput: "numeric",
    crmfeild: "new_baincome",
    instructions: "All revenue sources from business."
  },
  {
    alias: "Monthly Business Expenses",
    description:
      "The business's expenses for a typical month. Please include all items on the P&L, including employee salaries and owner(s) draw.  ",
    example: "15000",
    modelField: "opp_declared_business_expenses",
    userInput: "numeric",
    crmfeild: "new_batotalbusinessexpense",
    instructions:
      "Include all terms on business bank statements or P&L including employee salaries and/or owner(s) draw."
  },
  {
    alias: "Monthly Household Income",
    description:
      "The primary borrower's income in a typical month. Please include all forms of income, including business owner take home salary from the business.",
    example: "4500",
    modelField: "opp_declared_household_income",
    userInput: "numeric",
    crmfeild: "new_patotalincome",
    instructions:
      "Please include all forms of income, including business owner take home salary from the business."
  },
  {
    alias: "Monthly Personal Debt",
    description:
      "The value of the primary borrower's debt payments in a typical month. Please include monthly expenses related to long term and short debt. Please include credit card, mortgage, student loans, car loans, etc.",
    example: "200",
    modelField: "_personaldebt",
    userInput: "numeric",
    crmfeild: "new_pamonthlydebt",
    instructions:
      "Please include monthly expenses related to long-term and short-term debt. Include credit card, mortgage, student loans, car loans and other debt."
  },
  {
    alias: "First Name",
    description: "The first name of the applicant",
    example: "Tom",
    modelField: "first_name",
    userInput: "none",
    // preFieldNote: "Please provide the applicant’s first name",
    crmfeild: "firstname"
  },
  {
    alias: "Last Name",
    description: "The last name of the applicant.",
    example: "Selleck",
    modelField: "last_name",
    userInput: "none",
    // preFieldNote: "Please provide the applicant’s last name.",
    crmfeild: "lastname"
  },
  {
    alias: "Applicant Email",
    description: "The email address of the applicant",
    example: "tselleck@gmail.com",
    modelField: "email_address",
    userInput: "none",
    // contactField: true,
    // preFieldNote: "Please provide the applicant’s email address.",
    crmfeild: "emailaddress1"
  },
  {
    alias: "Applicant Phone",
    description: "The phone number of the applicant",
    example: "2025551234",
    modelField: "applicant_phone",
    userInput: "none",
    // contactField: true,
    // preFieldNote: "Please provide the applicant’s phone number.",
    crmfeild: "telephone1"
  },
  // {
  //   alias: "First Name",
  //   description: "The first name of the applicant",
  //   example: "Tom",
  //   modelField: "firstname",
  //   userInput: "text",
  //   //fieldIndent: true,
  //   preFieldNote: "Only Required when Submitting to LiftFund:",
  //   contactField: true,
  //   crmfeild: "firstname",
  // },
  // {
  //   alias: "Last Name",
  //   description: "The last name of the applicant",
  //   example: "Selleck",
  //   modelField: "lastname",
  //   userInput: "text",
  //   //fieldIndent: true,
  //   contactField: true,
  //   crmfeild: "lastname",
  // },
  // {
  //   alias: "Applicant Email",
  //   description: "The email address of the applicant",
  //   example: "tselleck@gmail.com",
  //   modelField: "email",
  //   userInput: "text",
  //   //fieldIndent: true,
  //   contactField: true,
  //   crmfeild: "emailaddress1",
  // },
  {
    alias: "Model Elapsed Opp Established Date",
    description: "The Model Elapsed Opp Established Date",
    example: "example",
    modelField: "model_date_opp_established_date",
    userInput: "none",
    // preFieldNote: "Please provide the applicant’s established date.",
    crmfeild: "new_days_since_established"
  },
  {
    alias: "Declared Gross Business Surplus",
    description: "The declared gross business surplus of applicant.",
    example: "2000",
    modelField: "opp_declared_gross_business_surplus",
    userInput: "none",
    // preFieldNote: "Please provide the applicant’s business surplus.",
    crmfeild: "new_bagrosssurplus"
  },
  {
    alias: "Equity",
    description: "The declared new equity.",
    example: "3000",
    modelField: "equity",
    userInput: "none",
    // preFieldNote: "Please provide the applicant’s opp equity.",
    crmfeild: "new_equity"
  },
  {
    alias: "Declared Personal Debt Income Ratio",
    description: "The declared personal debt of the applicant.",
    example: "3000",
    modelField: "opp_declared_personal_debt_income_ratio",
    userInput: "none",
    // preFieldNote: "Please provide the applicant’s income ratio.",
    crmfeild: "new_paratio"
  }
];

export const ContactAliases = [
  {
    alias: "First Name",
    description: "The first name of the applicant",
    example: "Tom",
    //modelField: "firstname",
    userInput: "text",
    //fieldIndent: true,
    preFieldNote: "Please provide the lead’s contact information",
    contactField: true,
    crmfeild: "firstname"
  },
  {
    alias: "Last Name",
    description: "The last name of the applicant",
    example: "Selleck",
    userInput: "text",
    contactField: true,
    crmfeild: "lastname"
  },
  {
    alias: "Applicant Email",
    description: "The email address of the applicant",
    example: "tselleck@gmail.com",
    userInput: "text",
    contactField: true,
    crmfeild: "emailaddress1"
  },
  {
    alias: "Applicant Phone",
    description: "The Phone number of the applicant",
    example: "202-555-1234",
    userInput: "text",
    contactField: true,
    crmfeild: "telephone1"
  }
];



// WEBPACK FOOTER //
// ./src/services/paramprocessor.js